module.exports = __webpack_public_path__ + "img/RVB_Exval-favicon-color-1-2.6ad2afa2.svg";